import Datagent from "datagent";
import Schema from "datagent/src/classes/Schema.class";
import {respondData,requestHandle} from "../utils";
import Fecha from "@/utils/type/Fecha"

const {filter, format, getField, awaitTo} = Datagent.Hooks;

import {defaults} from "datagent/src/utils";
const name = "operationLog";
const Model = Datagent.Model({
    name,
    fields: {
        'id'             : {type: Number, default: null},
        'resourceKey'    : {type: String, default:''}, //操作日志对象编码
        'action'         : {type: Number, default: ''}, // 操作
        'detail'         : {type: String, default: ''}, //操作细节
        'operator'       : {type: val=>Fecha(val, "YYYY-MM-DD"), default: ''}, // 操作人
        'operationTime'  : {type: String, default: ''}, // 操作时间
    },
    methods: {
        fetch(params, opts) {
            const types = ['reportData', 'sentiment', 'punishment', 'target', 'company', 'listedTarget', 'listedCompany', 'carbonCompany', 'carbonReportData','carbonTarget']
          const { origin } = defaults(opts);
          let { type, ...query } = params
          if(types.indexOf(params.type)<0) throw Error(`The type must use ${types.map(s=>`'${s}'`).join(' ')}`)
          // switch(type){
          //   case 'company':
          //     query.companyClassification = 'company'
          //     break;
          //   case 'listedCompany':
          //     query.companyClassification = 'listedCompany'
          //     type="company"
          //     break;
          //   case 'target':
          //     query.targetClassification = 'target'
          //     break;
          //   case 'listedTarget':
          //     query.targetClassification = 'listedTarget'
          //     type="target"
          //     break;
          // }
          return this.remote(origin).get(`${this._url}/${type}`, query)
        },
    },
    hooks: {
        fetch: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
export default Model;
